<div class="container-fluid ml-n2">
  <processing-view :processing="processing"></processing-view>

  <!-- Delete All Keys confirmation dialog box-->
  <!-- OTPW入力ダイアログ -->
  <b-modal v-model="deleteallkeysconfirmotpwinput" size="lg" header-bg-variant="secondary" header-text-variant="light"
    no-stacking centered no-close-on-backdrop no-close-on-esc @show="modalShowWEvent('show')"
    @hidden="modalShowWEvent('hide')">

    <template v-slot:header>
      <div class="text-center w-100">
        {{ $t('message.common_title_confirmation') }}
      </div>
    </template>

    <template v-slot:default>
      <div class="text-left w-auto m-4">
        <div class="text-center">
          <b>{{ $t('imb.delete_all_keys_confirm_start_caution_header') }}</b>
        </div>
        <div class="text-left mb-4">
          <b v-html="$t('imb.delete_all_keys_confirm_start_caution_message')"></b>
        </div>
        <div class="text-left mb-4">
          <b>{{ $t('imb.delete_all_keys_confirm_otpw') }}</b>
        </div>
        <b-form-group label-for="otpw-input" :state="isAlert.data.valid">
          <b-form-input id="otpw-input" v-model="otpw" :state="isAlert.data.valid" maxlength="9"
            autocomplete="off"></b-form-input>
          <b-form-invalid-feedback>{{ $t(isAlert.data.msg, [isAlert.data.length]) }}</b-form-invalid-feedback>
        </b-form-group>
      </div>
    </template>

    <template v-slot:footer>
      <div class="text-center w-100">
        <b-button variant="outline-primary" v-on:click="cancelButtonClick()" class="ml-4">
          {{ $t('message.common_button_cancel') }}
        </b-button>
        <b-button variant="primary" v-on:click="onOtpwInputOkButtonClick()" class="ml-4">
          {{ $t('message.common_button_ok') }}
        </b-button>
      </div>
    </template>
  </b-modal>

  <!-- Delete All Keys confirm otpw error dialog box -->
  <b-modal v-model="deleteallkeyserrorconfirmotpw" size="lg" header-bg-variant="danger" header-text-variant="light"
    no-stacking centered no-close-on-backdrop no-close-on-esc @show="modalShowWEvent('show')"
    @hidden="modalShowWEvent('hide')">

    <template v-slot:header>
      <div class="text-center w-100">
        {{ $t('message.common_title_error') }}
      </div>
    </template>

    <template v-slot:default>
      <div class="text-center w-100 m-4">
        <p class="mb-3">
          {{$t('imb.error_delete_all_keys_confirm_otpw')}}
        </p>
      </div>
    </template>

    <template v-slot:footer>
      <div class="text-center w-100">
        <b-button size="sm" variant="primary" class="ml-4" v-on:click="dialogCloseProcess()">
          {{ $t('message.common_button_ok') }}
        </b-button>
      </div>
    </template>
  </b-modal>

  <!-- Delete All Keys confirmation dialog box-->
  <b-modal v-model="deleteallkeysconfirmtostart" size="lg" header-bg-variant="secondary" header-text-variant="light"
    no-stacking centered no-close-on-backdrop no-close-on-esc @show="modalShowWEvent('show')"
    @hidden="modalShowWEvent('hide')">
    <template v-slot:header>
      <div class="text-center w-100">{{$t('message.common_title_confirmation')}}</div>
    </template>
    <template v-slot:default>
      <div class="text-left w-auto m-4">
        <b v-html="$t('imb.delete_all_keys_confirm_start')"></b>
      </div>
    </template>
    <template v-slot:footer>
      <div class="text-center w-100">
        <b-button variant="outline-primary" @click="cancelButtonClick()">
          {{ $t('message.common_button_cancel')}}
        </b-button>
        <b-button variant="primary" v-on:click="onDeleteAllKeysConfirmToStartOkButtonClick()" class="ml-4">
          {{ $t('message.common_button_ok')}}
        </b-button>
      </div>
    </template>
  </b-modal>

  <!-- Delete All Keys success -->
  <b-modal v-model="deleteallkeyssuccess" size="lg" header-bg-variant="success" header-text-variant="light" no-stacking
    centered no-close-on-backdrop no-close-on-esc @show="modalShowWEvent('show')" @hidden="modalShowWEvent('hide')">
    <template v-slot:header>
      <div class="text-center w-100">
        {{ $t('message.common_title_success') }}
      </div>
    </template>

    <template v-slot:default>
      <div>
        <div class="text-center w-100 mt-3">
          {{$t('imb.delete_all_keys_success')}}
        </div>
        <div class="text-center w-100">
          {{ $t('imb.common_num_reg_keys_without_unit', [imbStatusInfo.num_of_registered_keys]) }}
        </div>
        <div class="text-center w-100">
          {{ $t('imb.common_press_ok') }}
        </div>
      </div>
    </template>

    <template v-slot:footer>
      <div class="text-center w-100">
        <b-button size="sm" variant="primary" v-on:click="successOkButtonClick()" class="ml-2 mr-2">
          {{ $t('message.common_button_ok') }}
        </b-button>
      </div>
    </template>
  </b-modal>

  <!-- Delete All Keys confirm the ignition is on -->
  <b-modal v-model="deleteallkeysconfirmigon" size="lg" header-bg-variant="secondary" header-text-variant="light"
    no-stacking centered no-close-on-backdrop no-close-on-esc @show="modalShowWEvent('show')"
    @hidden="modalShowWEvent('hide')">
    <template v-slot:header>
      <div class="text-center w-100">{{$t('message.common_title_confirmation')}}</div>
    </template>

    <template v-slot:default>
      <div>
        <div class="text-center w-100 mt-3">
          {{$t('imb.common_check_igni_on')}}
        </div>
      </div>
      <div>
        <div class="text-center w-100">
          <div class="checkbox-size-lg">
            <b-form-checkbox v-model="turnIgOnChecked">
              {{$t('imb.common_check_igni_on_done')}}
            </b-form-checkbox>
          </div>
        </div>
      </div>
    </template>

    <template v-slot:footer>
      <div class="text-center w-100">
        <b-button size="sm" variant="outline-primary" v-on:click="onIgOnDialogEndOfProcessButtonClick()" class="ml-2 mr-2">
          {{ $t('message.common_button_cancel')}}
        </b-button>
        <b-button size="sm" variant="primary" :disabled="!turnIgOnChecked" v-on:click="igOnOkButtonClick()"
          class="ml-2 mr-2">
          {{ $t('message.common_button_ok')}}
        </b-button>
      </div>
    </template>
  </b-modal>

  <!-- Delete All Keys turn on and confirm ignition -->
  <b-modal v-model="deleteallkeysconfirmigison" size="lg" header-bg-variant="secondary" header-text-variant="light"
    no-stacking centered no-close-on-backdrop no-close-on-esc @show="modalShowWEvent('show')"
    @hidden="modalShowWEvent('hide')">
    <template v-slot:header>
      <div class="text-center w-100">{{$t('message.common_title_confirmation')}}</div>
    </template>

    <template v-slot:default>
      <div>
        <div class="text-center w-100 mt-3" v-html="$t('imb.error_imb_ig_switch_is_on')">
        </div>
      </div>
      <div>
        <div class="text-center w-100">
          <div class="checkbox-size-lg">
            <b-form-checkbox v-model="turnIgOnChecked">
              {{$t('imb.common_check_igni_on_done')}}
            </b-form-checkbox>
          </div>
        </div>
      </div>
    </template>

    <template v-slot:footer>
      <div class="text-center w-100">
        <b-button size="sm" variant="outline-primary" v-on:click="onIgOnDialogEndOfProcessButtonClick()" class="ml-2 mr-2">
          {{ $t('message.common_button_cancel')}}
        </b-button>
        <b-button size="sm" variant="primary" :disabled="!turnIgOnChecked" v-on:click="igOnOkButtonClick()"
          class="ml-2 mr-2">
          {{ $t('message.common_button_ok')}}
        </b-button>
      </div>
    </template>
  </b-modal>

  <!-- Delete All Keys warning cannot detect IGON -->
  <b-modal v-model="deleteallkeyswarningigon" size="lg" header-bg-variant="warning" header-text-variant="light"
    no-stacking centered no-close-on-backdrop no-close-on-esc @show="modalShowWEvent('show')"
    @hidden="modalShowWEvent('hide')">
    <template v-slot:header>
      <div class="text-center w-100">{{$t('message.common_title_warning')}}</div>
    </template>

    <template v-slot:default>
      <div>
        <div class="text-center w-100 mt-3" v-html="$t('imb.common_cannot_detect_igni_on')">
        </div>
      </div>
      <div>
        <div class="text-center w-100">
          {{ $t('imb.common_press_ok') }}
        </div>
      </div>
    </template>

    <template v-slot:footer>
      <div class="text-center w-100">
        <b-button size="sm" variant="primary" v-on:click="onIgOnDialogEndOfProcessButtonClick()" class="ml-2 mr-2">
          {{ $t('message.common_button_ok') }}
        </b-button>
      </div>
    </template>
  </b-modal>

  <!-- Delete All Keys process is on going for Communicating with Body Integrated Unit or immobilizer CM -->
  <b-modal v-model="deleteallkeysprogresscommimbcm" size="lg" header-bg-variant="secondary" header-text-variant="light"
    no-stacking centered no-close-on-backdrop no-close-on-esc @show="modalShowWEvent('show')"
    @hidden="modalShowWEvent('hide')" hide-footer>
    <template v-slot:header>
      <div class="text-center w-100">{{ $t('imb.common_executing') }}
      </div>
    </template>

    <template v-slot:default>
      <div class="container-fluid mt-3 mb-4">
        <processing-view :processing="modelUpdateProcessing" class="update-processing-view"></processing-view>
      </div>
      <div class="text-center w-100">
        {{ $t('imb.common_process_comm_with_imb_cm') }}
      </div>
    </template>
  </b-modal>

  <!-- Delete All Keys processing -->
  <b-modal v-model="deleteallkeysprocessing" size="lg" header-bg-variant="secondary" header-text-variant="light"
    no-stacking centered no-close-on-backdrop no-close-on-esc @show="onProcessingModalShow"
    @hidden="onProcessingModalHidden" :hide-footer="!isType2">
    <template v-slot:header>
      <div class="text-center w-100">{{$t('imb.common_executing')}}</div>
    </template>

    <template v-slot:default>
      <div class="text-center w-100 mt-3">
        <div v-html="$t('imb.delete_all_keys_processing')"></div>
        <div v-if="isType2">
          {{ $t('imb.delete_all_keys_processing_keep_ig_on') }}
        </div>
        <div class="text-center mt-4">
          <cstm-progress :value="progressValue" :variant="progressVariant" :max="100" :label-disable="true">
          </cstm-progress>
          <div class="text-left mt-2">
            {{ $t('imb.delete_all_keys_processing_elapsed_time') }}: {{ formattedTime }}
          </div>
        </div>
      </div>
    </template>

    <template v-slot:footer>
      <div class="text-center w-100">
        <b-button size="sm" variant="outline-primary" :disabled="isCancelLocked" v-on:click="deleteAllKeysCancelButtonClick()" class="ml-2 mr-2">
          {{ $t('message.common_button_cancel') }}
        </b-button>
      </div>
    </template>
  </b-modal>

  <!-- Delete All Keys warning for key not found -->
  <b-modal v-model="deleteallkeyswarningkeynotfound" size="lg" header-bg-variant="warning" header-text-variant="light"
    no-stacking centered no-close-on-backdrop no-close-on-esc @show="modalShowWEvent('show')"
    @hidden="modalShowWEvent('hide')">
    <template v-slot:header>
      <div class="text-center w-100">{{$t('message.common_title_warning')}}</div>
    </template>

    <template v-slot:default>
      <div>
        <div class="text-center w-100 mt-3">
          {{ $t('imb.common_num_reg_keys_without_unit', [imbStatusInfo.num_of_registered_keys]) }}
        </div>
        <div class="text-center w-100">
          {{ $t('imb.error_delete_all_keys_no_key_registered') }}
        </div>
      </div>
      <div>
        <div class="text-center w-100">
          {{ $t('imb.common_press_ok') }}
        </div>
      </div>
    </template>

    <template v-slot:footer>
      <div class="text-center w-100">
        <b-button size="sm" variant="primary" v-on:click="onWarningKeyNotFoundOkButtonClick()" class="pr-5 pl-5">
          {{ $t('message.common_button_ok') }}
        </b-button>
      </div>
    </template>
  </b-modal>

  <!-- Delete All Keys warning for cancel -->
  <b-modal v-model="deleteallkeyswarningcancel" size="lg" header-bg-variant="warning" header-text-variant="light"
    no-stacking centered no-close-on-backdrop no-close-on-esc @show="modalShowWEvent('show')"
    @hidden="modalShowWEvent('hide')">
    <template v-slot:header>
      <div class="text-center w-100">{{$t('message.common_title_warning')}}</div>
    </template>

    <template v-slot:default>
      <div>
        <div class="text-center w-100 mt-3">
          {{ $t('imb.delete_all_keys_cancel') }}
        </div>
        <div class="text-center w-100">
          {{ $t('imb.common_num_reg_keys_without_unit', [imbStatusInfo.num_of_registered_keys]) }}
        </div>
      </div>
      <div>
        <div class="text-center w-100">
          {{ $t('imb.common_press_ok') }}
        </div>
      </div>
    </template>

    <template v-slot:footer>
      <div class="text-center w-100">
        <b-button size="sm" variant="primary"
          v-on:click="onErrorOkButtonClick('delete-all-keys-warning-cancel','delete-all-keys-end')" class="pr-5 pl-5">
          {{ $t('message.common_button_ok') }}
        </b-button>
      </div>
    </template>
  </b-modal>

  <!-- Delete All Keys error response -->
  <b-modal v-model="deleteallkeysfailure" size="lg" header-bg-variant="danger" header-text-variant="light" no-stacking
    centered no-close-on-backdrop no-close-on-esc @show="modalShowWEvent('show')" @hidden="modalShowWEvent('hide')">
    <template v-slot:header>
      <div class="text-center w-100">
        {{ $t('message.common_title_error') }}
      </div>
    </template>

    <template v-slot:default>
      <div v-if="!isCausesAndActionDialog(imbStatusInfo.error_code)">
        <div class="text-center w-100 mt-3" v-html="imbStatusInfo.error_message">
        </div>
      </div>
      <div v-else>
        <div class="col-12 text-left row mt-1">
          <div class="col-3 text-right">{{ $t('message.label_repro_error_code') }}:</div>
          <div class="col-9">{{ imbStatusInfo.error_code }}</div>
        </div>
        <div class="col-12 text-left row mt-1">
          <div class="col-3 text-right">{{ $t('message.label_repro_error_cause') }}:</div>
          <div class="col-9" v-html="imbStatusInfo.error_cause_message"></div>
        </div>
        <div class="col-12 text-left row mt-1">
          <div class="col-3 text-right">{{ $t('message.label_repro_error_action') }}:</div>
          <div class="col-9" v-html="imbStatusInfo.error_action_message"></div>
        </div>
      </div>
      <div>
        <div class="text-center w-100 mt-2">
          {{ $t('imb.common_press_ok') }}
        </div>
      </div>
    </template>

    <template v-slot:footer>
      <div class="text-center w-100">
        <b-button size="sm" variant="primary"
          v-on:click="onErrorOkButtonClick('delete-all-keys-failure','delete-all-keys-end')" class="ml-2 mr-2">
          {{ $t('message.common_button_ok') }}
        </b-button>
      </div>
    </template>
  </b-modal>

  <!-- Delete All Keys end -->
  <b-modal v-model="deleteallkeysend" size="lg" header-bg-variant="secondary" header-text-variant="light" no-stacking
    centered no-close-on-backdrop no-close-on-esc @show="modalShowWEvent('show')" @hidden="modalShowWEvent('hide')">
    <template v-slot:header>
      <div class="text-center w-100">{{$t('message.common_title_confirmation')}}</div>
    </template>

    <template v-slot:default>
      <div class="text-center w-100 mt-3">
        <div>{{ $t('imb.delete_all_keys_end') }}</div>
        <div v-if="isType2">
          {{ $t('imb.delete_all_keys_end_ig_off') }}
        </div>
      </div>
      <div v-if="isType2">
        <div class="text-center w-100">
          <div class="checkbox-size-lg">
            <b-form-checkbox v-model="turnIgOnChecked">
              {{ $t('imb.common_confirm_igni_off_removed_key') }}
            </b-form-checkbox>
          </div>
        </div>
      </div>
      <div v-else>
        <div class="text-center w-100">
          {{ $t('imb.common_press_ok') }}
        </div>
      </div>
    </template>

    <template v-slot:footer>
      <div class="text-center w-100">
        <b-button size="sm" variant="primary" :disabled="isType2 && !turnIgOnChecked"
          v-on:click="onDeleteAllKeysEndOkButtonClick()" class="ml-2 mr-2">
          {{ $t('message.common_button_ok') }}
        </b-button>
      </div>
    </template>
  </b-modal>

</div>
